/**
 * Application-wide constants
 */

/**
 * Support phone number in E.164 format (for tel: links)
 */
export const SUPPORT_PHONE_E164 = '+19174232715';

/**
 * Support phone number in display format
 */
export const SUPPORT_PHONE_DISPLAY = '917-423-2715';

export const DEFAULT_ORG_PHONE_NUMBER = '+19174232712';

export const SUPPORT_EMAIL = 'support@conduithealth.com';

export const links = {
  conduit_terms_of_service_url: 'https://www.conduithealth.com/terms',
  conduit_privacy_policy_url: 'https://www.conduithealth.com/privacy-policy',
  conduit_hipaa_notice_url: 'https://www.conduithealth.com/hipaa-hms',
} as const;

/**
 * Telehealth contact type values for the API
 */
export const TELEHEALTH_CONTACT_TYPE = {
  VIDEO: 'Secure Videochat',
  PHONE: 'Phone Call',
} as const;

export type TelehealthContactType =
  (typeof TELEHEALTH_CONTACT_TYPE)[keyof typeof TELEHEALTH_CONTACT_TYPE];

export const DEFAULT_TELEHEALTH_CONTACT_TYPE = TELEHEALTH_CONTACT_TYPE.VIDEO;

export const DEFAULT_VANTAGE_CONTACT_TYPE = TELEHEALTH_CONTACT_TYPE.PHONE;

export const NEW_PATIENT_VISIT_DURATION_IN_MINUTES = 20;
